import { apiLuckyBag } from '~/api/room'
import type { luckyBagInterface } from '@/types/apiType/roomType'

// 房间幸运红包
export const useLuckyBagStore = defineStore({
  id: 'luckyBag',
  state: () => ({
    luckyBagInfo: null as luckyBagInterface | null, // 幸运红包信息
    currentLuckyBagBanner: null as luckyBagInterface | null, // 当前播放的幸运红包横幅
    luckyBagBanners: [] as luckyBagInterface[] // 幸运红包横幅队列
  }),
  actions: {
    // 幸运红包信息
    setLuckyBagInfo(data: typeof this.luckyBagInfo) {
      this.luckyBagInfo = data
    },
    /**
     * 设置幸运红包状态是否已抢
     * @param hadGrab 是否已抢
     */
    setLuckyBagHadGrab(hadGrab: boolean) {
      this.luckyBagInfo && (this.luckyBagInfo.hadGrab = hadGrab)
    },
    /**
     * 添加幸运红包横幅
     * @param data 幸运红包信息
     */
    addLuckyBagBanner(data: luckyBagInterface) {
      if (this.currentLuckyBagBanner === null) {
        this.currentLuckyBagBanner = data
      } else {
        this.luckyBagBanners.push(data)
      }
    },
    /** 播放完成后 删除当前幸运红包横幅，播放下一个 */
    async nextLuckyBagBanner() {
      this.currentLuckyBagBanner = null
      await nextTick()
      if (this.luckyBagBanners.length > 0) {
        this.currentLuckyBagBanner = this.luckyBagBanners.shift() || null
      } else {
        this.currentLuckyBagBanner = null
      }
    },
    // 请求幸运红包信息
    async requestLuckyBagInfo() {
      const roomStore = useRoomStore()
      if (!roomStore.roomId) return
      const { code, data } = await apiLuckyBag({ roomId: roomStore.roomId })
      if (code === 200) {
        this.setLuckyBagInfo(data)
      }
    }
  }
})
